import React from "react";
import Skeleton from "../Skeleton/Skeleton";
import "../../containers/PaymentHistory/PaymentSummary.scss";
import "../../containers/Withdrawals/TransactionSummary.scss";
import "../../containers/PaymentHistory/ContributionList.scss";
import "../DestinationSelector/DestinationSelector.scss";

/** Matches `PaymentSummary` row layout (earnings / payment history lists). */
export function PaymentSummaryRowSkeleton() {
    return (
        <div className="payment-summary py-16" aria-hidden>
            <div className="d-flex aic gap-12">
                <Skeleton width="40px" height="40px" borderRadius="12px" className="m-0 p-0" />
                <div style={{ flex: 1, minWidth: 0 }}>
                    <div className="d-flex jcsb aic pb-4">
                        <Skeleton width="45%" height="16px" borderRadius="8px" className="m-0 p-0" />
                        <Skeleton width="72px" height="16px" borderRadius="8px" className="m-0 p-0" />
                    </div>
                    <Skeleton width="85%" height="14px" borderRadius="7px" className="m-0 p-0 mt-4" />
                </div>
            </div>
        </div>
    );
}

/** Matches `TransactionSummary` (withdrawals / payout rows). */
export function TransactionSummaryRowSkeleton() {
    return (
        <div className="transaction-container py-16" aria-hidden>
            <div className="d-flex aic jcsb">
                <Skeleton width="100px" height="20px" borderRadius="8px" className="m-0 p-0" />
                <Skeleton width="88px" height="16px" borderRadius="8px" className="m-0 p-0" />
            </div>
            <Skeleton width="70%" height="14px" borderRadius="7px" className="m-0 p-0 mt-8" />
        </div>
    );
}

/** Matches `SubscriptionSummary` (monthly contributions). */
export function SubscriptionSummaryRowSkeleton() {
    return (
        <div className="subscription-summary py-16" aria-hidden>
            <div className="d-flex jcsb aic pb-4">
                <Skeleton width="50%" height="16px" borderRadius="8px" className="m-0 p-0" />
                <Skeleton width="64px" height="16px" borderRadius="8px" className="m-0 p-0" />
            </div>
            <Skeleton width="65%" height="12px" borderRadius="6px" className="m-0 p-0" />
            <Skeleton width="140px" height="32px" borderRadius="8px" className="m-0 p-0 mt-16" />
        </div>
    );
}

/** Shipping method row inside selector modal. */
export function ShippingMethodSelectorRowSkeleton() {
    return (
        <div
            className="d-flex aic jcsb py-16"
            style={{ borderBottom: "1px solid #f0f0f0" }}
            aria-hidden
        >
            <div style={{ flex: 1, minWidth: 0 }}>
                <Skeleton width="70%" height="14px" borderRadius="6px" className="m-0 p-0" />
                <Skeleton width="55%" height="12px" borderRadius="6px" className="m-0 p-0 mt-8" />
            </div>
            <Skeleton width="24px" height="24px" borderRadius="6px" className="m-0 p-0" />
        </div>
    );
}

/** Full destination selector shell (header + search + grouped lines). */
export function DestinationSelectorSkeleton() {
    return (
        <div className="destination-selector" role="status" aria-label="Loading destinations">
            <div className="destination-selector-header ta-center mb-16">
                <Skeleton width="180px" height="18px" borderRadius="8px" className="m-0 p-0 mx-auto" />
            </div>
            <div className="destination-search mb-16">
                <Skeleton width="100%" height="44px" borderRadius="12px" className="m-0 p-0" />
            </div>
            {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="d-flex aic jcsb py-12" style={{ borderBottom: "1px solid #eee" }}>
                    <Skeleton width={`${40 + (i % 3) * 15}%`} height="14px" borderRadius="6px" className="m-0 p-0" />
                    <Skeleton width="20px" height="20px" borderRadius="4px" className="m-0 p-0" />
                </div>
            ))}
        </div>
    );
}
